import React from "react";
import { Modal, Box, Button } from "@mui/material";
import AccessibleTooltip from "../Tooltip/Tooltip.js";
import closeIcon from "../../assets/images/closeicon.svg";
import "./style.scss";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "12px",
  p: 3,
  width: "480px",
  maxHeight: "90vh",
  overflowY: "auto",
};

const DeviceDetailsModal = ({ open, onClose, device }) => {
  if (!device) return null;
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="device-details-title"
      aria-modal="true"
      role="dialog"
      className="globalForm addDeviceEntry"
    >
      <Box sx={style} className="mainModalBox">
        <div className="Modal_header">
          <h1 id="device-details-title">Device Details</h1>
          <AccessibleTooltip title="Close">
            <button
              aria-label="Close device details"
              onClick={onClose}
              data-testid="close-icon"
              className="close_button_modal"
            >
              <img src={closeIcon} alt="" aria-hidden="true" />
            </button>
          </AccessibleTooltip>
        </div>
        <div className="Modal_middle device-details">
          <dl>
            <div className="detail-row">
              <dt>Floor</dt>
              <dd>{device?.deviceLocationName ?? "--"}</dd>
            </div>
            <div className="detail-row">
              <dt>Device Type</dt>
              <dd>{device.type.name}</dd>
            </div>
            <div className="detail-row">
              <dt>Device Name</dt>
              <dd>{device.name}</dd>
            </div>
            <div className="detail-row">
              <dt>Device Make</dt>
              <dd>{device.deviceMake}</dd>
            </div>
            <div className="detail-row">
              <dt>Serial Number</dt>
              <dd>{device.serialNumber}</dd>
            </div>
            <div className="detail-row">
              <dt>Date Installed</dt>
              <dd>{device.dateInstalled ?? "--"}</dd>
            </div>
            <div className="detail-row">
              <dt>MAC Address</dt>
              <dd>{device.macAddress}</dd>
            </div>
            <div className="detail-row">
              <dt>IP Address</dt>
              <dd>{device.ipAddress}</dd>
            </div>
            <div className="detail-row">
              <dt>Status</dt>
              <dd>
                <span className={`status-chip ${device.status !== "idle" ? "ACTIVE" : "INACTIVE"}`}>
                  {device.status !== "idle" ? "In-Use" : "Idle"}
                </span>
              </dd>
            </div>
            <div className="detail-row">
              <dt>Topic Name</dt>
              <dd>{device.topicName}</dd>
            </div>
          </dl>
        </div>

        <div className="Modal_footer">
            <Box sx={{ display: "flex" }}>
                <Button
                    variant="contained"
                    className="saveBtn"
                    data-testid="save-button"
                    onClick={onClose}
                >
                    Close
                </Button>
            </Box>
        </div>
      </Box>
    </Modal>
  );
};

export default DeviceDetailsModal;
